import { createSelector } from '@ngrx/store';
import { getOrderBuilderState } from '../../../reducers';

/**
 * Exports retail specification state
 */
export const getRetailReviewPage = createSelector(
  getOrderBuilderState,
  state => {
    return state.retailReviewPage;
  },
);
